import CoreGlobalNavigationHeader from './CoreGlobalNavigationHeader';

export { type CoreGlobalNavigationHeaderProps } from './CoreGlobalNavigationHeader';
export default CoreGlobalNavigationHeader;
